(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deal-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const addToCartButtons = document.querySelectorAll('.deal-product-card__add-to-cart');

    addToCartButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = button.dataset.variantId;

        console.log(variantId);

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(variantId),
                  quantity: 1,
                },
              ],
            }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.description || '添加商品失败');
          }

          const data = await response.json();

          console.log('购物车数据:', data);
          console.log('商品数量:', data.item_count);

          // 安全地触发购物车更新事件
          try {
            // 检查购物车抽屉是否存在
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              // 触发购物车刷新事件并打开购物车抽屉
              document.dispatchEvent(
                new CustomEvent('cart:refresh', {
                  detail: { open: true }, // 设置为 true 来打开购物车抽屉
                })
              );
            }

            // 触发购物车数量更新事件
            if (data.item_count !== undefined) {
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: {
                    cart: data,
                    item_count: data.item_count,
                  },
                })
              );
            }

            // 触发更多可能的购物车更新事件
            document.dispatchEvent(new CustomEvent('cart:change', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: data } }));

            // 尝试直接调用购物车组件的更新方法
            if (window.Shopify && window.Shopify.onCartUpdate) {
              window.Shopify.onCartUpdate(data);
            }

            // 更新购物车数量显示
            const cartCountElements = document.querySelectorAll(
              'cart-count, [data-cart-count], .cart-count, #cart-count, [data-cart-item-count]'
            );
            cartCountElements.forEach((element) => {
              if (data.item_count > 0) {
                element.textContent = data.item_count > 99 ? '99+' : data.item_count.toString();
                element.removeAttribute('hidden');
                element.style.display = 'block';
              } else {
                element.setAttribute('hidden', '');
                element.style.display = 'none';
              }
            });

            // 额外尝试更新可能的购物车数量元素
            const allCartElements = document.querySelectorAll('[class*="cart"], [id*="cart"], [data-*="cart"]');
            allCartElements.forEach((element) => {
              const text = element.textContent || '';
              if (text.match(/^\d+$/) || text === '0') {
                // 如果元素内容看起来像数字，可能是购物车数量
                if (data.item_count > 0) {
                  element.textContent = data.item_count > 99 ? '99+' : data.item_count.toString();
                } else {
                  element.textContent = '0';
                }
              }
            });
          } catch (cartError) {
            console.warn('购物车更新警告:', cartError);
          }

          // 添加成功动画效果
          button.style.transform = 'scale(1.1)';
          setTimeout(() => {
            button.style.transform = 'scale(1)';
          }, 200);
        } catch (error) {
          console.error('加购错误:', error);

          let errorMessage = '添加失败，请重试';
          if (error.message.includes('库存不足') || error.message.includes('out of stock')) {
            errorMessage = '商品库存不足';
          } else if (error.message.includes('variant')) {
            errorMessage = '商品规格不可用';
          }

          console.error(errorMessage);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dhjdtv4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sihoo-highlight-tabs')) return;

    class SihooHighlightTabs extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedOnce) return;
        this.isConnectedOnce = true;

        this.track = this.querySelector('[data-spht-track]');
        this.stickyNav = this.querySelector('[data-spht-sticky-nav]');
        this.navScroller = this.querySelector('[data-spht-nav-scroller]');
        this.tabs = Array.from(this.querySelectorAll('[data-spht-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-spht-panel]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.progressFills = Array.from(this.querySelectorAll('[data-spht-progress]'));
        this.autoplaySentinel = this.querySelector('[data-spht-autoplay-sentinel]');
        this.cardRails = Array.from(this.querySelectorAll('[data-spht-card-rail]'));

        if (!this.track || !this.tabs.length || !this.panels.length) return;

        this.abortController = new AbortController();
        this.mobileCardsQuery = window.matchMedia('(max-width: 767px)');
        this.activeIndex = -1;
        this.programmaticIndex = null;
        this.scrollSettleTimer = 0;
        this.autoplayEnabled = this.dataset.autoRotate === 'true'
          && this.panels.length > 1
          && !(window.Shopify && window.Shopify.designMode);
        this.autoplayDuration = Math.min(
          20000,
          Math.max(5000, (Number.parseFloat(this.dataset.rotationInterval) || 8) * 1000)
        );
        this.autoplayElapsed = 0;
        this.autoplayLastTime = 0;
        this.autoplayFrame = 0;
        this.autoplayInteractionTimer = 0;
        this.autoplayManualScrolling = false;
        this.automaticallyPausedVideos = new WeakSet();
        this.automaticallyPlayedVideos = new WeakSet();
        this.videoVisibilityRatios = new WeakMap();
        this.scrollFrame = 0;
        this.heightFrame = 0;
        this.pageScrollFrame = 0;
        this.resizeFrame = 0;

        const signal = this.abortController.signal;
        this.initializeVideos(signal);
        this.initializeCardRails(signal);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.goTo(index, true, 'manual'), { signal });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index), { signal });
        });

        this.track.addEventListener('scroll', () => this.onTrackScroll(), { passive: true, signal });
        this.track.addEventListener('scrollend', () => this.onTrackScrollEnd(), { signal });
        this.track.addEventListener('pointerdown', () => this.onTrackInteractionStart(), { passive: true, signal });
        this.track.addEventListener('wheel', (event) => this.onTrackWheel(event), { passive: true, signal });
        window.addEventListener('pointerup', () => this.onTrackInteractionEnd(), { passive: true, signal });
        window.addEventListener('pointercancel', () => this.onTrackInteractionEnd(), { passive: true, signal });
        window.addEventListener('scroll', () => this.schedulePageNavigationSync(), { passive: true, signal });
        window.addEventListener('resize', () => this.onViewportResize(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });

        document.addEventListener('visibilitychange', () => {
          this.syncVideos();
        }, { signal });

        if (this.mobileCardsQuery.addEventListener) {
          this.mobileCardsQuery.addEventListener('change', () => {
            this.syncCardRailAccessibility();
            this.syncVideos();
          }, { signal });
        }

        this.resizeObserver = new ResizeObserver((entries) => {
          const activePanel = this.panels[this.activeIndex];
          if (entries.some((entry) => entry.target === activePanel)) {
            this.updateHeight(this.activeIndex);
          }
          this.syncVideos();
          this.schedulePageNavigationSync();
        });

        this.panels.forEach((panel) => this.resizeObserver.observe(panel));

        this.videoVisibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
            this.videoVisibilityRatios.set(entry.target, ratio);
          });
          this.syncVideos();
        }, { threshold: [0, 0.2, 0.55, 0.75] });
        this.videos.forEach((video) => this.videoVisibilityObserver.observe(video));

        this.setActive(0, false);
        requestAnimationFrame(() => {
          this.updateHeight(0);
          this.syncVideos();
          this.syncPageNavigation();
          this.syncCardRailAccessibility();
          this.syncAutoplay();
        });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.videoVisibilityObserver) this.videoVisibilityObserver.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.heightFrame) cancelAnimationFrame(this.heightFrame);
        if (this.pageScrollFrame) cancelAnimationFrame(this.pageScrollFrame);
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.restorePageNavigation();
        this.isConnectedOnce = false;
      }

      initializeCardRails(signal) {
        this.cardRails.forEach((rail) => {
          rail.addEventListener('scroll', () => this.beginManualScroll(), { passive: true, signal });
          rail.addEventListener('scrollend', () => this.finishManualScroll(), { signal });
          rail.addEventListener('focusin', (event) => {
            if (!this.mobileCardsQuery.matches || !rail.hasAttribute('tabindex')) return;
            const card = event.target.closest('.spht__card');
            if (!card) return;

            card.scrollIntoView({
              behavior: this.reducedMotionQuery ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }, { signal });
        });
      }

      syncCardRailAccessibility() {
        this.cardRails.forEach((rail) => {
          const isScrollable = this.mobileCardsQuery.matches
            && rail.scrollWidth > rail.clientWidth + 1;

          if (isScrollable) {
            rail.tabIndex = 0;
            rail.setAttribute('aria-label', rail.dataset.sphtRailLabel || 'Product features');
          } else {
            rail.removeAttribute('tabindex');
            rail.removeAttribute('aria-label');
          }
        });
      }

      // 轮播始终可运行，忽略所有暂停条件
      canAutoplay() {
        return this.autoplayEnabled;
      }

      syncAutoplay() {
        if (!this.isConnected) return;

        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        this.autoplayFrame = 0;
        this.autoplayLastTime = 0;
        this.renderAutoplayProgress();

        if (!this.canAutoplay()) {
          this.dataset.autoplayState = this.autoplayEnabled ? 'paused' : 'disabled';
          return;
        }

        this.dataset.autoplayState = 'running';
        this.autoplayLastTime = performance.now();
        this.autoplayFrame = requestAnimationFrame((time) => this.tickAutoplay(time));
      }

      tickAutoplay(time) {
        if (!this.canAutoplay()) {
          this.syncAutoplay();
          return;
        }

        const elapsedSinceLastFrame = Math.max(0, Math.min(500, time - this.autoplayLastTime));
        this.autoplayElapsed += elapsedSinceLastFrame;
        this.autoplayLastTime = time;
        this.renderAutoplayProgress();

        if (this.autoplayElapsed >= this.autoplayDuration) {
          this.autoplayFrame = 0;
          this.autoplayLastTime = 0;
          this.autoplayElapsed = 0;
          this.renderAutoplayProgress();

          const nextIndex = (this.activeIndex + 1) % this.panels.length;
          const animate = nextIndex !== 0;
          this.goTo(nextIndex, animate, 'autoplay');
          return;
        }

        this.autoplayFrame = requestAnimationFrame((nextTime) => this.tickAutoplay(nextTime));
      }

      resetAutoplayProgress(restart = true) {
        if (this.autoplayFrame) cancelAnimationFrame(this.autoplayFrame);
        this.autoplayFrame = 0;
        this.autoplayLastTime = 0;
        this.autoplayElapsed = 0;
        this.renderAutoplayProgress();
        if (restart) this.syncAutoplay();
      }

      renderAutoplayProgress() {
        const progress = this.autoplayEnabled
          ? Math.min(1, Math.max(0, this.autoplayElapsed / this.autoplayDuration))
          : 1;

        this.progressFills.forEach((fill, index) => {
          const value = index === this.activeIndex ? progress : 0;
          fill.style.transform = `scaleX(${value})`;
        });
      }

      onTrackInteractionStart() {
        this.cancelProgrammaticScroll();
        // 不暂停轮播
      }

      onTrackInteractionEnd() {
        // 不暂停轮播
      }

      onTrackWheel(event) {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        this.cancelProgrammaticScroll();
        this.beginManualScroll();
      }

      beginManualScroll() {
        if (!this.autoplayManualScrolling) {
          this.autoplayManualScrolling = true;
          // 不暂停轮播
        }

        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.autoplayInteractionTimer = setTimeout(() => this.finishManualScroll(), 240);
      }

      finishManualScroll() {
        if (this.autoplayInteractionTimer) clearTimeout(this.autoplayInteractionTimer);
        this.autoplayInteractionTimer = 0;
        if (!this.autoplayManualScrolling) return;

        this.autoplayManualScrolling = false;
        // 不暂停轮播
      }

      onTrackScrollEnd() {
        if (this.programmaticIndex !== null) {
          this.finishProgrammaticScroll();
        } else {
          this.finishManualScroll();
        }
      }

      onTabKeydown(event, index) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        this.tabs[nextIndex].focus({ preventScroll: true });
        this.goTo(nextIndex, true, 'manual');
      }

      onTrackScroll() {
        if (this.programmaticIndex !== null) {
          if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
          this.scrollSettleTimer = setTimeout(() => this.finishProgrammaticScroll(), 180);
          return;
        }

        this.beginManualScroll();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          if (this.programmaticIndex !== null) return;

          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + (trackRect.width / 2);
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.panels.forEach((panel, index) => {
            const panelRect = panel.getBoundingClientRect();
            const panelCenter = panelRect.left + (panelRect.width / 2);
            const distance = Math.abs(panelCenter - trackCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex !== this.activeIndex) this.setActive(closestIndex, true);
        });
      }

      onBlockSelect(event) {
        const panel = event.target.closest('[data-spht-panel]');
        if (!panel || !this.contains(panel)) return;

        const index = this.panels.indexOf(panel);
        if (index > -1) this.goTo(index, false, 'manual');
      }

      goTo(index, animate, source = 'manual') {
        const panel = this.panels[index];
        if (!panel) return;

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        if (source === 'manual') this.resetAutoplayProgress(false);
        this.programmaticIndex = index;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.setActive(index, true);

        const trackRect = this.track.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const distance = panelRect.left - trackRect.left;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: distance,
          behavior: animate && !prefersReducedMotion ? 'smooth' : 'auto'
        });

        if (!animate || prefersReducedMotion || Math.abs(distance) <= 1) {
          requestAnimationFrame(() => this.finishProgrammaticScroll());
        } else {
          this.scrollSettleTimer = setTimeout(() => this.finishProgrammaticScroll(), 800);
        }
      }

      finishProgrammaticScroll() {
        if (this.programmaticIndex === null) return;

        const index = this.programmaticIndex;
        const panel = this.panels[index];
        this.programmaticIndex = null;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = 0;

        if (panel) {
          const trackRect = this.track.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const remainingDistance = panelRect.left - trackRect.left;

          if (Math.abs(remainingDistance) > 1) {
            this.track.scrollBy({ left: remainingDistance, behavior: 'auto' });
          }
        }

        this.setActive(index, true);
        // 不暂停轮播
      }

      cancelProgrammaticScroll() {
        if (this.programmaticIndex === null) return;

        this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'auto' });
        this.programmaticIndex = null;
        if (this.scrollSettleTimer) clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = 0;
        this.onTrackScroll();
        // 不暂停轮播
      }

      setActive(index, centerNavigation) {
        if (!this.panels[index]) return;

        if (index === this.activeIndex) {
          if (centerNavigation) this.centerActiveTab(index);
          return;
        }

        this.activeIndex = index;
        this.resetAutoplayProgress(false);

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.setAttribute('aria-hidden', String(!isActive));
          if (isActive) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        });

        if (centerNavigation) this.centerActiveTab(index);
        this.updateHeight(index);
        this.syncVideos();
        // 关键修复：切换后重新启动轮播计时器，让进度条继续加载
        this.syncAutoplay();
      }

      centerActiveTab(index) {
        const tab = this.tabs[index];
        if (!tab || !this.navScroller) return;

        const scrollerRect = this.navScroller.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const distance = (tabRect.left + tabRect.width / 2) - (scrollerRect.left + scrollerRect.width / 2);

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.navScroller.scrollBy({
          left: distance,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      }

      updateHeight(index) {
        if (this.heightFrame) cancelAnimationFrame(this.heightFrame);

        this.heightFrame = requestAnimationFrame(() => {
          const panel = this.panels[index];
          if (!panel || !this.track) return;

          this.track.style.height = `${Math.ceil(panel.getBoundingClientRect().height)}px`;
        });
      }

      onViewportResize() {
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);

        this.resizeFrame = requestAnimationFrame(() => {
          this.goTo(this.activeIndex, false, 'system');
          this.syncCardRailAccessibility();
          this.schedulePageNavigationSync();
        });
      }

      schedulePageNavigationSync() {
        if (this.pageScrollFrame) cancelAnimationFrame(this.pageScrollFrame);

        this.pageScrollFrame = requestAnimationFrame(() => {
          this.syncPageNavigation();
          this.syncVideos();
        });
      }

      syncPageNavigation() {
        if (!this.stickyNav) return;

        const pageNavigation = document.querySelector('.anchor-nav-wrapper');
        if (!pageNavigation || this.contains(pageNavigation)) {
          this.style.removeProperty('--spht-page-anchor-offset');
          return;
        }

        if (this.dataset.hidePageAnchor !== 'true') {
          this.restorePageNavigation();
          this.style.setProperty('--spht-page-anchor-offset', `${pageNavigation.offsetHeight}px`);
          return;
        }

        this.style.removeProperty('--spht-page-anchor-offset');

        const sectionRect = this.getBoundingClientRect();
        const navigationRect = this.stickyNav.getBoundingClientRect();
        const stickyTop = Number.parseFloat(window.getComputedStyle(this.stickyNav).top) || 0;
        const takeoverDistance = pageNavigation.offsetHeight || navigationRect.height;
        const isApproachingStickyLine = navigationRect.top <= stickyTop + takeoverDistance;
        const localNavigationIsPresent = navigationRect.bottom > stickyTop && sectionRect.bottom > stickyTop;
        const shouldHide = isApproachingStickyLine && localNavigationIsPresent;

        if (shouldHide) {
          if (!pageNavigation.classList.contains('spht__page-anchor--hidden')) {
            pageNavigation.dataset.sphtHiddenBy = this.id;
            pageNavigation.dataset.sphtPreviousAriaHidden = pageNavigation.hasAttribute('aria-hidden')
              ? pageNavigation.getAttribute('aria-hidden')
              : '__missing__';
            pageNavigation.dataset.sphtHadInert = String(pageNavigation.hasAttribute('inert'));
            pageNavigation.classList.add('spht__page-anchor--hidden');
            pageNavigation.setAttribute('aria-hidden', 'true');
            pageNavigation.setAttribute('inert', '');
          }
        } else {
          this.restorePageNavigation();
        }
      }

      restorePageNavigation() {
        const pageNavigation = document.querySelector('.anchor-nav-wrapper');
        if (!pageNavigation || pageNavigation.dataset.sphtHiddenBy !== this.id) return;

        pageNavigation.classList.remove('spht__page-anchor--hidden');

        if (pageNavigation.dataset.sphtPreviousAriaHidden === '__missing__') {
          pageNavigation.removeAttribute('aria-hidden');
        } else {
          pageNavigation.setAttribute('aria-hidden', pageNavigation.dataset.sphtPreviousAriaHidden);
        }

        if (pageNavigation.dataset.sphtHadInert !== 'true') {
          pageNavigation.removeAttribute('inert');
        }

        delete pageNavigation.dataset.sphtHiddenBy;
        delete pageNavigation.dataset.sphtPreviousAriaHidden;
        delete pageNavigation.dataset.sphtHadInert;
      }

      initializeVideos(signal) {
        const showConfiguredControls = this.dataset.videoControls === 'true';
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.controls = prefersReducedMotion ? true : showConfiguredControls;

          video.addEventListener('pause', () => {
            if (this.automaticallyPausedVideos.has(video)) {
              this.automaticallyPausedVideos.delete(video);
              return;
            }

            video.dataset.sphtUserPaused = 'true';
          }, { signal });

          video.addEventListener('play', () => {
            if (this.automaticallyPlayedVideos.has(video)) {
              this.automaticallyPlayedVideos.delete(video);
              return;
            }

            delete video.dataset.sphtUserPaused;
            video.dataset.sphtUserStarted = 'true';
          }, { signal });
        });
      }

      updateVideoPreferences() {
        const showConfiguredControls = this.dataset.videoControls === 'true';
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.videos.forEach((video) => {
          video.controls = prefersReducedMotion ? true : showConfiguredControls;
        });
      }

      pauseVideo(video) {
        if (video.paused) return;

        this.automaticallyPausedVideos.add(video);
        video.pause();
        setTimeout(() => this.automaticallyPausedVideos.delete(video), 1000);
      }

      playVideo(video) {
        if (!video.paused) return;

        this.automaticallyPlayedVideos.add(video);
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => this.automaticallyPlayedVideos.delete(video));
        }

        setTimeout(() => this.automaticallyPlayedVideos.delete(video), 1000);
      }

      syncVideos() {
        this.panels.forEach((panel, panelIndex) => {
          const isActivePanel = panelIndex === this.activeIndex;

          panel.querySelectorAll('video').forEach((video) => {
            if (!isActivePanel) {
              this.pauseVideo(video);
              return;
            }

            const isDisplayed = video.getClientRects().length > 0;
            const visibilityRatio = this.videoVisibilityRatios.get(video) || 0;
            const isMobileRailVideo = this.mobileCardsQuery.matches
              && Boolean(video.closest('[data-spht-card-rail]'));
            const minimumVisibility = isMobileRailVideo ? 0.55 : 0.2;
            const isEligible = !document.hidden && isDisplayed && visibilityRatio >= minimumVisibility;
            const userPaused = video.dataset.sphtUserPaused === 'true';
            const userStarted = video.dataset.sphtUserStarted === 'true';
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!isEligible) {
              this.pauseVideo(video);
            } else if (prefersReducedMotion) {
              if (!userStarted || userPaused) this.pauseVideo(video);
            } else if (userPaused) {
              this.pauseVideo(video);
            } else if (video.muted) {
              this.playVideo(video);
            }
          });
        });
      }
    }

    customElements.define('sihoo-highlight-tabs', SihooHighlightTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sihoo-bf-countdown')) {
    class SihooBFCountdown extends HTMLElement {
      static get observedAttributes() {
        return ['data-end-date', 'data-end-time', 'data-utc-offset', 'data-expiry-mode', 'data-design-mode'];
      }

      connectedCallback() {
        this.stop();
        cancelAnimationFrame(this.frame);
        // Wait for children when an already-registered element is parsed or reinserted.
        this.frame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.stop();
      }

      attributeChangedCallback(name, previous, next) {
        if (previous !== next && this.isConnected) this.connectedCallback();
      }

      getDeadline() {
        const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec((this.dataset.endDate || '').trim());
        const time = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec((this.dataset.endTime || '').trim());
        const offset = /^([+-])(\d{2}):(\d{2})$/.exec((this.dataset.utcOffset || '').trim());
        if (!date || !time || !offset) return NaN;

        const year = Number(date[1]);
        const month = Number(date[2]);
        const day = Number(date[3]);
        const hour = Number(time[1]);
        const minute = Number(time[2]);
        const second = Number(time[3] || 0);
        const offsetHours = Number(offset[2]);
        const offsetMinutes = Number(offset[3]);
        if (year < 1970 || hour > 23 || minute > 59 || second > 59 || offsetHours > 14 || offsetMinutes > 59 || (offsetHours === 14 && offsetMinutes !== 0)) return NaN;

        const local = Date.UTC(year, month - 1, day, hour, minute, second);
        const check = new Date(local);
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
        const offsetTotal = (offsetHours * 60 + offsetMinutes) * (offset[1] === '+' ? 1 : -1);
        return local - offsetTotal * 60000;
      }

      start() {
        if (!this.isConnected) return;
        this.stop();
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-countdown-unit="' + unit + '"]'));
        this.grid = this.querySelector('[role="timer"]');
        if (!this.grid || this.units.some(unit => !unit)) return;
        this.deadline = this.getDeadline();
        const hint = this.querySelector('.sbf__countdown-hint');

        if (!Number.isFinite(this.deadline)) {
          this.hidden = this.dataset.designMode !== 'true';
          this.units.forEach(unit => { unit.textContent = '--'; });
          this.grid.setAttribute('aria-label', 'Countdown not configured');
          if (hint) hint.hidden = false;
          return;
        }

        if (hint) hint.hidden = true;
        this.hidden = false;
        if (!this.update()) return;
        this.interval = setInterval(() => this.update(), 1000);
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      update() {
        if (!this.isConnected) {
          this.stop();
          return false;
        }
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.style.setProperty('--sbf-countdown-digits', String(Math.max(2, String(values[0]).length)));
        this.units.forEach((unit, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (unit.textContent !== value) unit.textContent = value;
        });
        this.grid.setAttribute('aria-label', values[0] + ' days, ' + values[1] + ' hours, ' + values[2] + ' minutes, ' + values[3] + ' seconds');
        this.hidden = remaining === 0 && this.dataset.expiryMode === 'hide';
        if (remaining === 0) this.stop();
        return remaining > 0;
      }

      stop() {
        clearInterval(this.interval);
        this.interval = null;
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        this.onVisibility = null;
      }
    }
    customElements.define('sihoo-bf-countdown', SihooBFCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-free-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-free-order')) {
    class PreBfFreeOrder extends HTMLElement {
      // One shared lock for all instances, including simultaneous modal dialogs.
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleClick(event) {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-rules-open]');
        if (opener) {
          if (dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          return;
        }
        if (event.target.closest('[data-rules-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            dialog.close();
          }
        }
      }

      handleClose(event) {
        if (!event.target.matches('.pbfo__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (owners.has(this)) return;
        if (owners.size === 0) {
          const style = document.documentElement.style;
          PreBfFreeOrder.previousOverflow = style.getPropertyValue('overflow');
          PreBfFreeOrder.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (!owners.delete(this) || owners.size > 0) return;
        const style = document.documentElement.style;
        if (PreBfFreeOrder.previousOverflow) {
          style.setProperty('overflow', PreBfFreeOrder.previousOverflow, PreBfFreeOrder.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('pre-bf-free-order', PreBfFreeOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
  /* DE-owned element tag; no dependencies on window.FoxTheme or US theme JS. */
  if (!customElements.get('de-pre-bf-subscribe-popup')) {
    class DePreBfSubscribePopup extends HTMLElement {
      static scrollOwners = new Set();
      static previousOverflow = null;
      static ownsOverflow = false;

      connectedCallback() {
        if (this.eventsAttached) return;
        this.eventsAttached = true;
        this.editorSelected = false;
        this.visibilityFrame = null;
        this.opener = null;

        this.onClick = this.handleClick.bind(this);
        this.onDialogClose = this.handleClose.bind(this);
        this.onScroll = this.queueVisibility.bind(this);
        this.onEditorSelect = (event) => this.handleEditorSelection(event, true);
        this.onEditorDeselect = (event) => this.handleEditorSelection(event, false);

        this.addEventListener('click', this.onClick);
        /* Native dialog `close` doesn't bubble; use capture. */
        this.addEventListener('close', this.onDialogClose, true);
        if (this.dataset.triggerMode === 'scroll') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        if (this.dataset.editorMode === 'true') {
          document.addEventListener('shopify:section:select', this.onEditorSelect);
          document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
        }
        this.queueVisibility();
      }

      disconnectedCallback() {
        if (!this.eventsAttached) return;
        this.eventsAttached = false;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onDialogClose, true);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        if (this.visibilityFrame !== null) cancelAnimationFrame(this.visibilityFrame);
        this.visibilityFrame = null;

        const dialog = this.querySelector('.pbsp__dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleEditorSelection(event, isSelected) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
        this.editorSelected = isSelected;
        this.queueVisibility();
      }

      queueVisibility() {
        if (this.visibilityFrame !== null) return;
        this.visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
      }

      syncVisibility() {
        this.visibilityFrame = null;
        const floating = this.querySelector('[data-pbsp-floating]');
        if (!floating) return;
        const threshold = Math.max(1, Number(this.dataset.scrollThreshold) || 300);
        const isVisible = this.editorSelected ||
          this.dataset.triggerMode !== 'scroll' || window.scrollY >= threshold;
        floating.classList.toggle('is-visible', isVisible);
      }

      handleClick(event) {
        const minimize = event.target.closest('[data-pbsp-minimize]');
        if (minimize && this.contains(minimize)) {
          const floating = this.querySelector('[data-pbsp-floating]');
          if (floating) floating.classList.add('is-minimized');
          return;
        }

        const dialog = this.querySelector('.pbsp__dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-pbsp-open]');
        if (opener && this.contains(opener)) {
          if (dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          requestAnimationFrame(() => {
            if (!dialog.open) return;
            const field = dialog.querySelector('input[type="email"]');
            const closeButton = dialog.querySelector('[data-pbsp-close]');
            const focusTarget = field && !field.disabled ? field : closeButton;
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
          return;
        }

        const closeButton = event.target.closest('[data-pbsp-close]');
        if (closeButton && this.contains(closeButton)) {
          dialog.close();
          return;
        }

        /* Dismiss only clicks on this dialog's backdrop, not Mamba content. */
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom;
          if (outside) dialog.close();
        }
      }

      handleClose(event) {
        if (event.target !== this.querySelector('.pbsp__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) {
          this.opener.focus({ preventScroll: true });
        }
        this.opener = null;
      }

      lockScroll() {
        const owners = DePreBfSubscribePopup.scrollOwners;
        if (owners.has(this)) return;
        if (!owners.size) {
          const root = document.documentElement;
          const style = root.style;
          DePreBfSubscribePopup.previousOverflow = {
            value: style.getPropertyValue('overflow'),
            priority: style.getPropertyPriority('overflow')
          };
          /* Do not override an existing Sleek/app scroll lock. */
          const rootLocked = /^(hidden|clip)$/.test(getComputedStyle(root).overflowY);
          const bodyLocked = document.body &&
            /^(hidden|clip)$/.test(getComputedStyle(document.body).overflowY);
          DePreBfSubscribePopup.ownsOverflow = !rootLocked && !bodyLocked;
          if (DePreBfSubscribePopup.ownsOverflow) {
            style.setProperty('overflow', 'hidden', 'important');
          }
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = DePreBfSubscribePopup.scrollOwners;
        if (!owners.delete(this) || owners.size) return;
        const style = document.documentElement.style;
        /* Restore only while our inline value is still present. If a different
           value was written by the DE theme/app, leave it untouched. */
        if (DePreBfSubscribePopup.ownsOverflow &&
            style.getPropertyValue('overflow') === 'hidden' &&
            style.getPropertyPriority('overflow') === 'important') {
          const previous = DePreBfSubscribePopup.previousOverflow;
          if (previous && previous.value) {
            style.setProperty('overflow', previous.value, previous.priority);
          } else {
            style.removeProperty('overflow');
          }
        }
        DePreBfSubscribePopup.previousOverflow = null;
        DePreBfSubscribePopup.ownsOverflow = false;
      }
    }
    customElements.define('de-pre-bf-subscribe-popup', DePreBfSubscribePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-pre-bf-v2')) {
    customElements.define('de-pre-bf-v2', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      syncMambaPlacement() {
        if (!this.pbvMamba || !this.mobileQuery) return;
        const destination = this.mobileQuery.matches ? this.pbvMambaMobile : this.pbvMambaDesktop;
        // Keep one stable form ID and preserve the live form DOM when viewport changes.
        if (destination && this.pbvMamba.parentElement !== destination) destination.appendChild(this.pbvMamba);
      }

      // Mamba owns submission and success. This code only decorates its INPUT state.
      // Do not trigger submit(), click() or replace any app-managed form nodes.
      decorateMambaForm() {
        const root = this.pbvMamba;
        if (!root || !root.isConnected) return;
        const form = root.querySelector('.mambasms-form-newsletter-form > form');
        const email = form?.querySelector('.mambasms-form-input-field, input[type="email"]');
        const submit = form?.querySelector('.mambasms-form-submit-btn, button[type="submit"]');
        const visible = node => {
          if (!node || !node.isConnected || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
          if (!node.getClientRects().length) return false;
          const cs = window.getComputedStyle(node);
          return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) !== 0;
        };
        // Hidden success markup may exist before anyone subscribes. Check its
        // RENDERED visibility, never its mere presence in the document.
        const successSelectors = [
          '[data-modal-success]', '[data-modal-subscribed]',
          '.mambasms-form-success', '.mambasms-form-success-message',
          '[class*="subscription-success" i]', '[class*="subscribe-success" i]'
        ];
        let successVisible = successSelectors.some(selector =>
          Array.from(root.querySelectorAll(selector)).some(node => visible(node) && !!node.textContent.trim())
        );
        if (!successVisible) {
          successVisible = Array.from(root.querySelectorAll('.mambasms-form-text,[role="status"]'))
            .some(node => visible(node) && /(?:anmeldung|registrierung|abonnement|subscription|subscribed).{0,36}(?:erfolgreich|successfully|successful|bestätigt)|(?:erfolgreich).{0,20}(?:angemeldet|registriert)|thank you/i.test(node.textContent.trim()));
        }
        // If the form inputs are still in the DOM but hidden after a successful
        // submission, the success view always takes precedence.
        const formReady = !!(email && submit && visible(email) && visible(submit));
        const view = successVisible ? 'feedback' : (formReady ? 'form' : 'loading');
        if (root.dataset.pbvView !== view) root.dataset.pbvView = view;
        if (!formReady || successVisible) return;
        // Extra DE campaign copy before the real email field isn't part of
        // the slim US-style CTA. Never suppress consent, interactive UI, errors,
        // success or content occurring after the email field.
        const isBeforeEmail = element => !!(element.compareDocumentPosition(email) & Node.DOCUMENT_POSITION_FOLLOWING);
        const important = 'input,button,select,textarea,a,[role="alert"],[role="status"],[role="checkbox"],[data-modal-success],[data-modal-subscribed],.mambasms-form-success,.mambasms-form-error';
        form.querySelectorAll('.mambasms-form-section').forEach(element => {
          const mark = isBeforeEmail(element) && !element.querySelector(important) && !!element.textContent.trim();
          if (element.classList.contains('pbv__mamba-promo-copy') !== mark) element.classList.toggle('pbv__mamba-promo-copy', mark);
        });
        form.querySelectorAll('.mambasms-form-text').forEach(element => {
          const mark = isBeforeEmail(element) && !element.closest('[role="alert"],[role="status"],.mambasms-form-input-error,.mambasms-form-success') && !element.querySelector(important);
          if (element.classList.contains('pbv__mamba-promo-copy') !== mark) element.classList.toggle('pbv__mamba-promo-copy', mark);
        });
      }

      init() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.mobileQuery = window.matchMedia('(max-width: 768.98px)');
        this.pbvMamba = this.querySelector('[data-pbv-mamba]');
        this.pbvMambaDesktop = this.querySelector('[data-pbv-mamba-desktop]');
        this.pbvMambaMobile = this.querySelector('[data-pbv-mamba-mobile]');
        this.syncMambaPlacement();
        this.mambaObserver?.disconnect();
        if (this.pbvMamba && 'MutationObserver' in window) {
          // Mamba can switch between input/success states by toggling classes,
          // inline display or replacing nodes. Coalesce mutations into a frame.
          this.mambaObserver = new MutationObserver(() => {
            if (this.mambaDecorateFrame) return;
            this.mambaDecorateFrame = requestAnimationFrame(() => {
              this.mambaDecorateFrame = null;
              this.decorateMambaForm();
            });
          });
          this.mambaObserver.observe(this.pbvMamba, {
            childList: true, subtree: true,
            attributes: true, attributeFilter: ['class','style','hidden','aria-hidden']
          });
        }
        this.decorateMambaForm();
        this.posterWarmupReached = false;
        this.videoPlaybackTokens = new WeakMap();
        this.posterDecodePromises = new WeakMap();
        this.decodedPosters = new WeakSet();
        this.panels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
        this.accordion = this.querySelector('[data-accordion]');
        this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.desktopHotspots = Array.from(this.querySelectorAll('[data-desktop-hotspot]'));
        this.mobileHotspots = Array.from(this.querySelectorAll('[data-mobile-hotspot]'));
        this.back = this.querySelector('[data-cover-button]');
        this.status = this.querySelector('[data-status]');
        this.desktopCurrent = null;
        this.lastDesktopTrigger = null;
        this.lastMobileTrigger = null;
        this.modal = document.getElementById(this.dataset.modalId);
        if (this.modal) {
          this.modalPanel = this.modal.querySelector('[data-modal-panel]');
          this.modalScroll = this.modal.querySelector('[data-modal-scroll]');
          this.modalFeatures = Array.from(this.modal.querySelectorAll('[data-modal-feature]'));
          this.modalCount = this.modal.querySelector('[data-modal-count]');
          this.modalCurrent = null;
          this.availableMobile = this.mobileHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
          this.modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => this.stepModal(-1), opts);
          this.modal.querySelector('[data-modal-next]')?.addEventListener('click', () => this.stepModal(1), opts);
          this.modal.querySelector('[data-modal-close]')?.addEventListener('click', () => this.closeModal(), opts);
          this.modal.addEventListener('click', event => {
            // The viewport-sized dialog receives clicks outside its panel.
            if (event.target !== this.modal) return;
            const box = this.modalPanel?.getBoundingClientRect();
            if (!box || event.clientX < box.left || event.clientX > box.right ||
              event.clientY < box.top || event.clientY > box.bottom) this.closeModal();
          }, opts);
          this.modal.addEventListener('cancel', event => {
            event.preventDefault(); // Animate before native close.
            this.closeModal();
          }, opts);
          this.modal.addEventListener('close', () => this.afterModalClose(), opts);

          let touchStart = null;
          this.modalScroll?.addEventListener('touchstart', event => {
            if (event.touches.length !== 1 || event.target.closest('video, a, button')) {
              touchStart = null;
              return;
            }
            touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchend', event => {
            if (!touchStart || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStart.x;
            const dy = event.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.35) {
              this.stepModal(dx < 0 ? 1 : -1);
            }
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchcancel', () => { touchStart = null; }, opts);
        }

        this.selectDesktop(null, false);
        this.addEventListener('click', event => {
          const pcHotspot = event.target.closest('[data-desktop-hotspot]');
          if (pcHotspot && !pcHotspot.disabled) {
            this.lastDesktopTrigger = pcHotspot;
            this.selectDesktop(pcHotspot.dataset.blockId);
            this.accordionItems.find(item => item.dataset.blockId === pcHotspot.dataset.blockId)
              ?.querySelector('[data-accordion-button]')?.focus({ preventScroll: true });
            return;
          }
          const accordionButton = event.target.closest('[data-accordion-button]');
          if (accordionButton && !accordionButton.disabled) {
            // Selecting an already-open detail keeps it open. Use Back to overview to close.
            this.selectDesktop(accordionButton.dataset.blockId);
            return;
          }
          if (event.target.closest('[data-cover-button]')) {
            this.returnToCover();
            return;
          }
          const mobileHotspot = event.target.closest('[data-mobile-hotspot]');
          if (mobileHotspot && !mobileHotspot.disabled) this.openModal(mobileHotspot.dataset.blockId, mobileHotspot);
        }, opts);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.desktopCurrent && !this.mobileQuery.matches) {
            event.preventDefault();
            this.returnToCover();
            return;
          }
          const button = event.target.closest('[data-accordion-button]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const enabled = Array.from(this.querySelectorAll('[data-accordion-button]:not(:disabled)'));
          const index = enabled.indexOf(button);
          if (index < 0 || !enabled.length) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = enabled.length - 1;
          else nextIndex = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
          enabled[nextIndex].focus();
          this.selectDesktop(enabled[nextIndex].dataset.blockId);
        }, opts);

        // Native dialog traps Tab and handles ESC. Only scope the optional
        // feature-navigation arrows to this dialog while it is topmost.
        this.modal?.addEventListener('keydown', event => {
          if (!this.modal.open) return;
          // Keep modal keys out of Sleek's document-level drawer handlers.
          // The native cancel event still performs ESC close.
          if (event.key === 'Escape') { event.stopPropagation(); return; }
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
          event.stopPropagation();
          event.preventDefault();
          this.stepModal(event.key === 'ArrowRight' ? 1 : -1);
        }, opts);
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (!blockId || !this.panels.some(panel => panel.dataset.blockId === blockId)) return;
          if (this.mobileQuery.matches) {
            const trigger = this.mobileHotspots.find(button => button.dataset.blockId === blockId);
            if (trigger && !trigger.disabled) this.openModal(blockId, trigger);
          } else {
            this.selectDesktop(blockId);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAllVideos();
        }, opts);
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', () => {
            this.syncMambaPlacement();
            if (!this.mobileQuery.matches) this.closeModal(true);
            else this.selectDesktop(null, false);
            // If the user rotates/resizes after approaching this section, hydrate only
            // the new device layout. Do not request the unused layout in advance.
            if (this.posterWarmupReached) this.preparePostersForCurrentDevice();
          }, opts);
        }
        if ('IntersectionObserver' in window) {
          // Pre-warm CDN still images around 500px before the section.
          // Video URLs remain inert in data-src until the shopper selects a feature.
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.posterWarmupReached = true;
            this.preparePostersForCurrentDevice();
            this.preloadObserver?.disconnect();
          }, { rootMargin: '500px 0px', threshold: 0 });
          this.preloadObserver.observe(this);

          // Preserve the original behavior: pause desktop video when offscreen.
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0]?.isIntersecting) this.pauseDesktopVideos();
          });
          this.observer.observe(this);
        } else {
          // Older browsers: prepare image posters, but keep video URLs deferred.
          this.posterWarmupReached = true;
          this.preparePostersForCurrentDevice();
        }
      }

      // CDN preview images can be fetched and decoded ahead of use without
      // initializing any video sources. Only the current device's posters are warmed.
      preparePostersForCurrentDevice() {
        const root = this.mobileQuery?.matches ? this.modal : this;
        const device = this.mobileQuery?.matches ? 'mobile' : 'desktop';
        root?.querySelectorAll(`[data-pbv-video="${device}"]`).forEach(video => {
          const image = video.closest('[data-pbv-video-shell]')?.querySelector('.pbv__video-placeholder img');
          this.preparePoster(image);
        });
      }

      // Resolve after the actual image is decoded, rather than merely having
      // a network request in progress. Promise is cached for repeat hotspot visits.
      preparePoster(image) {
        if (!image) return Promise.resolve(false);
        const existing = this.posterDecodePromises.get(image);
        if (existing) return existing;
        image.loading = 'eager';
        image.decoding = 'async';
        const decoded = new Promise(resolve => {
          const finish = loaded => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            if (!loaded) { resolve(false); return; }
            if (typeof image.decode === 'function') {
              image.decode().then(() => resolve(true)).catch(() => resolve(image.naturalWidth > 0));
            } else {
              resolve(true);
            }
          };
          const onLoad = () => finish(image.naturalWidth > 0);
          const onError = () => finish(false);
          if (image.complete) finish(image.naturalWidth > 0);
          else {
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
          }
        });
        const tracked = decoded.then(ready => {
          if (ready) this.decodedPosters.add(image);
          return ready;
        });
        this.posterDecodePromises.set(image, tracked);
        return tracked;
      }

      // Adapted from ra-video-gallery-01: actual CDN source URLs are stored in
      // data-src and set on <source> elements only on a feature click.
      activateVideoSource(video) {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
        if (video.dataset.poster && !video.hasAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        video.preload = 'auto';
        const deferredSources = video.querySelectorAll('source[data-src]');
        if (!deferredSources.length) return; // Already hydrated. Never call load() again.
        deferredSources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }

      // Only reveal moving footage once the browser has rendered a real decoded frame.
      // A thumbnail stays visible during buffering, unsupported autoplay and load failures.
      revealOnFirstFrame(video, token) {
        const shell = video.closest('[data-pbv-video-shell]');
        if (!shell) return;
        const reveal = () => {
          if (this.videoPlaybackTokens.get(video) !== token || video.paused || video.readyState < 2) return;
          if (shell.closest('[hidden]') || document.hidden) return;
          shell.classList.add('is-video-ready');
          const panel = video.closest('[data-desktop-panel]');
          if (panel && this.desktopCurrent === panel.dataset.blockId) {
            panel.style.visibility = '';
            this.toggleAttribute('data-feature-media-active', true);
          }
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          // Older Safari: wait for actual playback, then allow two paint frames.
          const afterPlayback = () => {
            requestAnimationFrame(() => requestAnimationFrame(reveal));
          };
          video.addEventListener('playing', afterPlayback, { once: true, signal: this.controller.signal });
          video.addEventListener('timeupdate', afterPlayback, { once: true, signal: this.controller.signal });
          if (!video.paused && video.currentTime > 0 && video.readyState >= 2) afterPlayback();
        }
      }

      // Keep the existing overview visible until either the selected item's
      // CDN poster has decoded or its first real video frame has been rendered.
      // This also handles a shopper jumping straight to this section by anchor.
      revealDesktopPanelWithPoster(panel, blockId) {
        const shell = panel?.querySelector('[data-pbv-video-shell]');
        if (!shell) return; // Non-video feature image keeps its original behavior.
        const preview = shell.querySelector('.pbv__video-placeholder img');
        if (preview && this.decodedPosters.has(preview)) return;
        panel.style.visibility = 'hidden';
        this.toggleAttribute('data-feature-media-active', false);
        this.preparePoster(preview).then(ready => {
          if (!this.isConnected || !ready || this.desktopCurrent !== blockId || panel.hidden) return;
          panel.style.visibility = '';
          this.toggleAttribute('data-feature-media-active', true);
        });
      }

      playVideo(video) {
        if (!video || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const token = (this.videoPlaybackTokens.get(video) || 0) + 1;
        this.videoPlaybackTokens.set(video, token);
        const shell = video.closest('[data-pbv-video-shell]');
        shell?.classList.remove('is-video-ready');
        // A newly opened mobile modal also requests its image first if the
        // section was reached before the 500px preload observer fired.
        this.preparePoster(shell?.querySelector('.pbv__video-placeholder img'));
        this.activateVideoSource(video);
        this.revealOnFirstFrame(video, token);
        const promise = video.play();
        promise?.catch(() => { /* Thumbnail remains visible if playback fails. */ });
      }

      selectDesktop(blockId, announce = true) {
        const panel = this.panels.find(item => item.dataset.blockId === blockId);
        this.pauseDesktopVideos();
        this.desktopCurrent = panel ? blockId : null;
        const hasMedia = Boolean(panel && panel.dataset.hasMedia === 'true');
        this.toggleAttribute('data-feature-active', Boolean(panel));
        this.toggleAttribute('data-feature-media-active', hasMedia);
        this.panels.forEach(item => {
          item.hidden = !hasMedia || item !== panel;
          item.style.visibility = '';
        });
        if (panel && hasMedia) this.revealDesktopPanelWithPoster(panel, blockId);
        if (this.accordion) this.accordion.hidden = !panel;
        if (this.back) this.back.hidden = !panel;
        this.accordionItems.forEach(item => {
          const active = Boolean(panel && item.dataset.blockId === blockId);
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-accordion-button]');
          const content = item.querySelector('[data-accordion-description]');
          if (button) button.setAttribute('aria-expanded', String(active));
          if (content) content.hidden = !active;
        });
        if (announce && this.status) {
          const button = this.accordionItems.find(item => item.dataset.blockId === blockId)?.querySelector('[data-accordion-button]');
          this.status.textContent = panel ? (button?.textContent || 'Feature').trim() : 'Back to overview';
        }
        this.playVideo(panel?.querySelector('video'));
      }

      returnToCover() {
        this.selectDesktop(null);
        if (this.lastDesktopTrigger?.isConnected) this.lastDesktopTrigger.focus({ preventScroll: true });
      }

      openModal(blockId, trigger) {
        if (!this.mobileQuery?.matches || !this.modal || !this.availableMobile.includes(blockId)) return;
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        const wasOpen = this.modal.open;
        const wasInteractive = this.modal.classList.contains('is-open');
        if (!wasOpen) {
          this.lastMobileTrigger = trigger || null;
          try { this.modal.showModal(); } catch (error) { return; }
        }
        this.showModalFeature(blockId, 1);
        requestAnimationFrame(() => {
          if (!this.isConnected || !this.modal?.open) return;
          this.modal.classList.add('is-open');
          if (!wasInteractive) this.playVideo(this.modalFeatures?.find(item => item.dataset.blockId === blockId)?.querySelector('video'));
          if (!wasOpen) this.modalPanel?.focus({ preventScroll: true });
        });
      }

      showModalFeature(blockId, direction) {
        const feature = this.modalFeatures?.find(item => item.dataset.blockId === blockId);
        if (!feature) return;
        this.pauseModalVideos();
        this.modalCurrent = blockId;
        this.modal.dataset.direction = direction < 0 ? 'prev' : 'next';
        this.modalFeatures.forEach(item => {
          item.hidden = item !== feature;
          item.classList.remove('is-entering');
        });
        feature.classList.add('is-entering');
        this.modal.setAttribute('aria-labelledby', feature.querySelector('.pbv__modal-title')?.id || '');
        const index = this.availableMobile.indexOf(blockId);
        if (this.modalCount) this.modalCount.textContent = `${index + 1} / ${this.availableMobile.length}`;
        if (this.modalScroll) this.modalScroll.scrollTop = 0;
        if (this.status) this.status.textContent = feature.querySelector('.pbv__modal-title')?.textContent?.trim() || 'Product feature';
        if (this.modal.classList.contains('is-open')) this.playVideo(feature.querySelector('video'));
      }

      stepModal(step) {
        if (!this.modal?.open || !this.availableMobile.length) return;
        const index = this.availableMobile.indexOf(this.modalCurrent);
        const next = (Math.max(0, index) + step + this.availableMobile.length) % this.availableMobile.length;
        this.showModalFeature(this.availableMobile[next], step);
      }

      closeModal(immediate = false) {
        if (!this.modal?.open) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal.classList.remove('is-open');
        this.pauseModalVideos();
        const finish = () => {
          this.closeTimer = null;
          if (this.modal?.open) this.modal.close();
        };
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else this.closeTimer = window.setTimeout(finish, 180);
      }

      afterModalClose() {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal?.classList.remove('is-open');
        this.pauseModalVideos();
        const trigger = this.lastMobileTrigger;
        if (trigger?.isConnected && this.mobileQuery?.matches) trigger.focus({ preventScroll: true });
        this.lastMobileTrigger = null;
        this.modalCurrent = null;
      }
      pauseVideo(video) {
        this.videoPlaybackTokens?.set(video, (this.videoPlaybackTokens.get(video) || 0) + 1);
        video.pause();
      }
      pauseDesktopVideos() { this.panels?.forEach(panel => panel.querySelectorAll('video').forEach(video => this.pauseVideo(video))); }
      pauseModalVideos() { this.modal?.querySelectorAll('video').forEach(video => this.pauseVideo(video)); }
      pauseAllVideos() { this.pauseDesktopVideos(); this.pauseModalVideos(); }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.controller?.abort();
        this.observer?.disconnect();
        this.mambaObserver?.disconnect();
        if (this.mambaDecorateFrame) cancelAnimationFrame(this.mambaDecorateFrame);
        this.mambaDecorateFrame = null;
        this.preloadObserver?.disconnect();
        this.pauseAllVideos();
        // A removed Shopify Section must release its native top-layer modal.
        if (this.modal?.open) this.modal.close();
        this.modal?.classList.remove('is-open');
        this.lastMobileTrigger = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-page-popup-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-page-popup-link')) {
    class PrePagePopupLink extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.floating = this.querySelector('[data-ppl-floating]');
        this.link = this.querySelector('[data-ppl-link]');
        this.minimizeButton = this.querySelector('[data-ppl-minimize]');
        this.label = this.querySelector('.ppl__label');
        if (!this.floating || !this.link) return;

        // Measure label while the minimized pill is laid out.
        // This keeps the original 320ms width transition smooth.
        if (this.label) {
          this.label.style.setProperty('--ppl-label-width', `${Math.max(120, Math.ceil(this.label.scrollWidth))}px`);
        }

        // Extra destination-page protection for different www spellings.
        try {
          const destination = new URL(this.link.href);
          const current = new URL(window.location.href);
          const host = (value) => value.replace(/^www\./i, '');
          const path = (value) => value.replace(/\/+$/, '') || '/';
          if (host(destination.hostname) === host(current.hostname) &&
              path(destination.pathname) === path(current.pathname)) {
            this.style.display = 'none';
            return;
          }
        } catch (error) {
          // Shopify's anchor handles navigation if URL parsing fails.
        }

        this._targetReached = false;
        this._expandedOnce = false;
        this._revealScrollY = null;
        this._lockedMinimized = false;
        this._targetElement = null;
        this._visibilityFrame = null;

        // Preserve the V4 manual-X session choice; auto collapse is not stored.
        if (!window.Shopify || !window.Shopify.designMode) {
          try {
            this._lockedMinimized = sessionStorage.getItem(this.dataset.storageKey) === 'minimized';
          } catch (error) {
            // Private browsing may disallow session storage.
          }
        }
        // Always start with the clickable gift icon and persistent badge.
        this.floating.classList.add('is-minimized');

        this._onMinimize = () => {
          this.minimize(true);
          this.link.focus({ preventScroll: true });
        };
        if (this.minimizeButton) {
          this.minimizeButton.addEventListener('click', this._onMinimize);
        }

        this._onScroll = () => this.scheduleSync();
        this._onResize = () => this.scheduleSync();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        this.scheduleSync();
      }

      disconnectedCallback() {
        if (this.minimizeButton && this._onMinimize) {
          this.minimizeButton.removeEventListener('click', this._onMinimize);
        }
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._visibilityFrame !== null && this._visibilityFrame !== undefined) {
          cancelAnimationFrame(this._visibilityFrame);
        }
        this._visibilityFrame = null;
        this._initialized = false;
      }

      scheduleSync() {
        if (this._visibilityFrame !== null) return;
        this._visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
      }

      findTargetSection() {
        if (this._targetElement && this._targetElement.isConnected) return this._targetElement;
        const id = (this.dataset.targetSectionId || '').trim().replace(/^#/, '');
        this._targetElement = id ? (document.getElementById(id) || document.getElementById(`shopify-section-${id}`)) : null;
        return this._targetElement;
      }

      minimize(rememberManualChoice = false) {
        this._lockedMinimized = true;
        this.floating.classList.add('is-minimized');
        if (rememberManualChoice) {
          try {
            sessionStorage.setItem(this.dataset.storageKey, 'minimized');
          } catch (error) {
            // Even without storage, the current page stays minimized.
          }
        }
      }

      syncVisibility() {
        this._visibilityFrame = null;
        if (!this.floating) return;
        const scrollY = window.scrollY || window.pageYOffset || 0;

        // Single Section-based expansion. Without a valid target Section ID,
        // the always-visible gift icon remains minimized and clickable.
        if (!this._targetReached) {
          const target = this.findTargetSection();
          if (target) {
            const rect = target.getBoundingClientRect();
            if (rect.top <= window.innerHeight * 0.85) {
              this._targetReached = true;
              if (!this._lockedMinimized && rect.bottom > 0) {
                this._expandedOnce = true;
                this._revealScrollY = scrollY;
                this.floating.classList.remove('is-minimized');
              } else {
                // Deep scroll restore past the target: show only an icon.
                this.minimize();
              }
            }
          }
        }

        // Auto collapse only after the pill has expanded, measured relative
        // to the expansion location rather than the page's scroll origin.
        if (this._expandedOnce && !this._lockedMinimized) {
          const distance = Math.max(0, Number(this.dataset.autoCollapseDistance) || 400);
          if (scrollY - this._revealScrollY >= distance) {
            this.minimize();
          }
        }
      }
    }
    customElements.define('pre-page-popup-link', PrePagePopupLink);
  }

  } catch(e) { console.error(e); }
})();
})();
